import { useCallback, useEffect, useRef, useState } from 'react';
import { useInterval } from './useInterval';

export const useRealtime = () => {
  const [count, setCount] = useState(0);

  function callback() {
    setCount(count + 1);
  }

  const secondsRef = useRef(0);
  const savedCallback = useRef(callback);

  useEffect(() => {
    savedCallback.current = callback;
  });

  const tick = useCallback(() => {
    const isInForeground = !document.hidden;
    const hasFocus = document.hasFocus != null ? document.hasFocus() : true;
    const every10Seconds = secondsRef.current % 10 === 0;
    const fireCallback = isInForeground && (hasFocus || every10Seconds);
    if (fireCallback) {
      savedCallback.current();
    }
    secondsRef.current = secondsRef.current + 1;
  }, []);

  useInterval(1000, tick);

  return count;
};
